import api, { unwrap } from './client';

/* Emprunts — un prêt, une ligne, tous les exercices. L'échéancier (encours,
   capital remboursé, intérêts) se calcule au SERVEUR : ici, rien que des
   appels. Chaque écriture renvoie la vue entière, l'écran n'a rien à recoller. */
export const getLoans = (tenantId, year) =>
  unwrap(api.get(`/financials/loans/${tenantId}`, { params: { year } }));

export const createLoan = (tenantId, year, payload) =>
  unwrap(api.post(`/financials/loans/${tenantId}`, payload, { params: { year } }));

export const patchLoan = (tenantId, loanId, year, payload) =>
  unwrap(api.patch(`/financials/loans/${tenantId}/${loanId}`, payload, { params: { year } }));

export const deleteLoan = (tenantId, loanId, year) =>
  unwrap(api.delete(`/financials/loans/${tenantId}/${loanId}`, { params: { year } }));

// Un remboursement saisi à la main, pour un mois. Montant vide = la ligne part.
export const setLoanPayment = (tenantId, loanId, year, month, amount) =>
  unwrap(api.put(`/financials/loans/${tenantId}/${loanId}/payment`, { amount },
    { params: { year, month } }));
